import { GRID_Z } from '../constants/zIndices'
import { getRenderOrder } from '~/components/DrawingCanvas/util/renderOrder'
import gridFrag from './grid.frg?raw'
import gridVert from './grid.vert?raw'
import { shaderMaterial } from '@react-three/drei'
import { extend, ShaderMaterialProps } from '@react-three/fiber'
import { Vector3 } from 'three'

declare module '@react-three/fiber' {
  interface ThreeElements {
    gridMeshMaterial: ShaderMaterialProps
  }
}

const blockBorderColor = new Vector3(0.85, 0.85, 0.85)
const cellBorderColor = new Vector3(0.9, 0.9, 0.9)
const bgColor = new Vector3(0.998, 0.998, 0.998)
const blockScale = 0.02
const cellsPerBlock = 5.0

const GridMeshMaterial = shaderMaterial(
  { blockBorderColor, cellBorderColor, bgColor, blockScale, cellsPerBlock },
  gridVert,
  gridFrag
)

extend({ GridMeshMaterial })

const TEN_THOUSAND_FEET = 20000

export const Grid = () => {
  return (
    <mesh renderOrder={getRenderOrder('GRID')} position-z={GRID_Z}>
      <planeGeometry args={[TEN_THOUSAND_FEET, TEN_THOUSAND_FEET]} />
      <gridMeshMaterial depthWrite={false} />
    </mesh>
  )
}
